import {AnyAction} from "redux";
import {createSelector} from "reselect";
import * as _ from "lodash";
import {getAllPowerSourcesData, getEnergyMixData, getPowerSourceLocationsData, getPowerSourcesData, IEnergyMixDictionary, IPowerSource, IPowerSourceLocation} from "../../../data/data";
import {getPopulatedPowerSources, getPowerSources} from "../powerSources";
import {getSeasonIndex} from "../season";
import {getEnergyDemand} from '../energy/energyDemand';
import {getDamage} from '../power-sources/damage';
import {getDeprecate} from '../power-sources/deprecate';


/**
 * get the ideal amount of energy output
 * @returns {number}
 */
export function getTargetEnergyOutput() : number
{
    const locations: IPowerSourceLocation[] = getPowerSourceLocationsData();
    const power_sources: IPowerSource[] = getAllPowerSourcesData();
    const ratios: IEnergyMixDictionary = getEnergyMixData();

    const energy_output_sum: number = _.reduce(power_sources, (sum: number, power_source: IPowerSource) =>
    {
        const source_output_data: number = power_source['energy-output'];

        // const multipliers: number[] = power_source['energy-multipliers'];

        // source_output = source_output_data

        // console.group('getTargetEnergyOutput:', power_source.id);
        // console.log(power_source);
        // console.log('source_output_data', source_output_data);
        // console.log('ratio', ratios[power_source.id]);
        // console.log('locations.length', locations.length);
        // console.log('n', ratios[power_source.id] * 0.01 * locations.length);
        // console.log('total', (ratios[power_source.id] * 0.01 * locations.length) * source_output_data);
        // // console.log('multipliers', multipliers);
        // console.groupEnd();

        // const source_output: number = _.isNumber(source_output_data) ? source_output_data as number : _.sum(source_output_data) * 0.25;

        return sum + (ratios[power_source.id] * 0.01 * locations.length) * source_output_data;
    }, 0);

    // console.info('energy_output_sum', energy_output_sum);

    return energy_output_sum;
}


//  define selectors

/**
 * get the total cost efficiency of all power sources
 */
export const getEnergyOutput = createSelector(

    [getPowerSources, getDamage, getDeprecate],

    (power_sources: IPowerSource[], damage: boolean[], deprecate: boolean[]) : number =>
    {
        if (! power_sources.length) return 0;

        const output_sum: number = _.reduce(power_sources, (total: number, power_source: IPowerSource, i: number) =>
        {
            // if (! power_source || damage[i] === true || deprecate[i] === true) return total;
            if (! power_source || deprecate[i] === true) return total;

            return total + power_source['energy-output'];
        }, 0);

        return Math.round(output_sum);
    }
);


/**
 * get the ratio of current energy output to target output
 */
export const getEnergyOutputRatio = createSelector(

    [getEnergyOutput, getEnergyDemand],

    (actual: number, demand: number) : number =>
    {
        if (! actual) return 0;

        const demand_min: number = Math.max(demand - 50, 0);
        const demand_max: number = demand + 50;

        const pc: number = (actual - demand_min) / (demand_max - demand_min);

        const ratio: number = _.clamp(pc, 0, 1);

        console.group('getEnergyOutputRatio');
        console.log('actual', actual);
        console.log('demand', demand);
        console.log('demand_min', demand_min);
        console.log('demand_max', demand_max);
        console.log('pc', pc);
        console.log('ratio', ratio);
        console.groupEnd();

        return parseFloat(ratio.toFixed(2));
    }
);


//  define the initial state

const initialState: number = 30;


/**
 * reducer: set the current energy output
 * @param {number} state
 * @param {AnyAction} action
 * @returns {number}
 */
export function energyOutput(state: number = initialState, action: AnyAction) : number
{
    switch (action.type)
    {
        default:

            return state;
    }
}



// WEBPACK FOOTER //
// ./src/ts/store/reducers/outputs/energyOutput.ts